import { useState } from "react";
import { getTheme, setTheme, type Theme } from "@/app/theme";

/** Переключатель темы из шапки макетов: «светлая» / «тёмная». */
export function ThemeToggle() {
  const [theme, set] = useState<Theme>(() => getTheme());
  const pick = (t: Theme) => {
    setTheme(t);
    set(t);
  };
  const btn = (t: Theme, label: string, extra = "") => (
    <button
      type="button"
      aria-pressed={theme === t}
      onClick={() => pick(t)}
      className={`border-0 px-3 py-1.5 font-mono text-[11px] cursor-pointer ${extra} ${theme === t ? "bg-acc text-accink" : "bg-transparent text-mut"}`}
    >
      {label}
    </button>
  );
  return (
    <div className="flex flex-none overflow-hidden whitespace-nowrap rounded-sm border border-bd" role="group" aria-label="тема">
      {btn("light", "светлая")}
      {btn("dark", "тёмная", "border-l border-bd")}
    </div>
  );
}
